import React, { type ReactElement } from 'react';
import { Icon, Tooltip } from '@saviynt/design-system';

import { TOKENS } from '../../../constants';

import './InfoTooltip.css';

export interface InfoTooltipProps {
  infoTooltipText: string | undefined;
}

function InfoTooltip({
  infoTooltipText,
}: InfoTooltipProps): ReactElement | null {
  if (!infoTooltipText) {
    return null;
  }

  return (
    <Tooltip
      text={infoTooltipText}
      trigger={
        <Icon kind='AlertInfoFilled' size='xSmall' color={TOKENS.CF_INF_STL} />
      }
      offset={4}
      classNames={{
        containerClassName: 'FF-InfoTooltip-container',
      }}
    />
  );
}

export default InfoTooltip;
